/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conflict_Reason_Manual_HintInputs */

const cs_ebr_conflict_reason_manual_hint = /** @type {(inputs: Ebr_Conflict_Reason_Manual_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnota v CRM se liší od posledního importu – někdo ji upravil ručně. Bez vaší volby zůstane hodnota z CRM.`)
};

const en_ebr_conflict_reason_manual_hint = /** @type {(inputs: Ebr_Conflict_Reason_Manual_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The CRM value differs from the last import – someone edited it manually. Without your choice the CRM value is kept.`)
};

/**
* | output |
* | --- |
* | "The CRM value differs from the last import – someone edited it manually. Without your choice the CRM value is kept." |
*
* @param {Ebr_Conflict_Reason_Manual_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conflict_reason_manual_hint = /** @type {((inputs?: Ebr_Conflict_Reason_Manual_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conflict_Reason_Manual_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conflict_reason_manual_hint(inputs)
	return cs_ebr_conflict_reason_manual_hint(inputs)
});